[
  {
    "data_types": ["Messages", "Metadata about content and messages"],
    "category": "User Communication Data",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [35, 40, 43, 44, 46, 48, 49, 50, 637, 638],
        "certainty": "high"
      },
      {
        "reason": "Security and identification",
        "evidence": [639, 640, 642, 643, 644, 645, 646, 647, 648, 649],
        "certainty": "high"
      },
      {
        "reason": "Train Machine Learning or AI models",
        "evidence": [637, 638, 692, 730, 792, 793, 837, 838],
        "certainty": "high"
      },
      {
        "reason": "Evaluate safety of content and content moderation",
        "evidence": [639, 640, 642, 643, 648, 649, 764, 765, 766, 767],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "Until account deletion",
        "evidence": [493, 494, 495, 496, 500, 501, 502, 503, 504, 505],
        "certainty": "high"
      },
      {
        "duration": "Up to 14 days",
        "evidence": [486, 497, 498, 499, 500, 501],
        "certainty": "high"
      },
      {
        "duration": "Longer for legal reasons and/or obligations",
        "evidence": [489, 491, 492, 517, 518, 519, 520, 521, 522, 523],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Partners and Affiliates",
        "evidence": [353, 354, 355, 356, 357, 358, 359, 360, 361, 362],
        "certainty": "high"
      },
      {
        "party": "Third party service providers",
        "evidence": [369, 373, 374, 420, 421, 424, 425, 426, 427, 428],
        "certainty": "high"
      },
      {
        "party": "Authorities",
        "evidence": [564, 565, 566, 567, 568, 569, 570, 571, 572, 573],
        "certainty": "high"
      }
    ],
    "sensitive": "partially sensitive"
  },
  {
    "data_types": [
      "Content you create (posts, comments, audio)",
      "Content from camera features or camera roll settings",
      "Content from voice-enabled features"
    ],
    "category": "User-Generated Content",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [33, 34, 40, 43, 44, 46, 48, 49, 637, 638],
        "certainty": "high"
      },
      {
        "reason": "Improve and personalize services",
        "evidence": [171, 172, 184, 185, 186, 187, 188, 189, 687, 688],
        "certainty": "high"
      },
      {
        "reason": "Train Machine Learning or AI models",
        "evidence": [637, 638, 692, 693, 730, 731, 792, 793, 837, 838],
        "certainty": "high"
      },
      {
        "reason": "Targeted and personalized advertisements",
        "evidence": [174, 175, 176, 177, 178, 179, 180, 181, 182, 183],
        "certainty": "high"
      },
      {
        "reason": "Evaluate safety of content and content moderation",
        "evidence": [639, 640, 642, 643, 648, 649, 764, 765, 766, 767],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "Until account deletion",
        "evidence": [493, 494, 495, 496, 502, 503, 504, 505, 506, 507],
        "certainty": "high"
      },
      {
        "duration": "Longer for legal reasons and/or obligations",
        "evidence": [489, 491, 492, 517, 518, 519, 520, 521, 522, 523],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Partners and Affiliates",
        "evidence": [353, 354, 355, 356, 357, 358, 359, 360, 361, 362],
        "certainty": "high"
      },
      {
        "party": "Third party service providers",
        "evidence": [369, 373, 374, 420, 421, 424, 425, 426, 427, 428],
        "certainty": "high"
      },
      {
        "party": "Authorities",
        "evidence": [564, 565, 566, 567, 568, 569, 570, 571, 572, 573],
        "certainty": "high"
      },
      {
        "party": "General public",
        "evidence": [289, 290, 291, 292, 293, 294, 295, 296, 297, 298],
        "certainty": "high"
      }
    ],
    "sensitive": "partially sensitive"
  },
  {
    "data_types": [
      "Public profile information (name, username, profile picture)",
      "Friends, followers, and other connections"
    ],
    "category": "Profile and Social Graph Data",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [33, 40, 43, 44, 46, 48, 49, 637, 638, 692],
        "certainty": "high"
      },
      {
        "reason": "Improve and personalize services",
        "evidence": [171, 172, 184, 185, 186, 187, 188, 189, 687, 688],
        "certainty": "high"
      },
      {
        "reason": "Security and identification",
        "evidence": [639, 640, 642, 643, 648, 649, 695, 696, 697, 698],
        "certainty": "high"
      },
      {
        "reason": "Targeted and personalized advertisements",
        "evidence": [174, 175, 176, 177, 178, 179, 180, 181, 182, 183],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "Until account deletion",
        "evidence": [493, 494, 495, 496, 502, 503, 504, 505, 506, 507],
        "certainty": "high"
      },
      {
        "duration": "Longer for legal reasons and/or obligations",
        "evidence": [489, 491, 492, 517, 518, 519, 520, 521, 522, 523],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Partners and Affiliates",
        "evidence": [353, 354, 355, 356, 357, 358, 359, 360, 361, 362],
        "certainty": "high"
      },
      {
        "party": "Third party service providers",
        "evidence": [369, 373, 374, 420, 421, 424, 425, 426, 427, 428],
        "certainty": "high"
      },
      {
        "party": "Authorities",
        "evidence": [564, 565, 566, 567, 568, 569, 570, 571, 572, 573],
        "certainty": "high"
      },
      {
        "party": "General public",
        "evidence": [289, 290, 291, 292, 293, 294, 295, 296, 297, 298],
        "certainty": "high"
      }
    ],
    "sensitive": "partially sensitive"
  },
  {
    "data_types": ["Apps and features usage data", "Actions taken in apps and features"],
    "category": "Usage Data",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [43, 44, 46, 48, 49, 637, 638, 687, 688, 692],
        "certainty": "high"
      },
      {
        "reason": "Improve and personalize services",
        "evidence": [171, 172, 184, 185, 186, 187, 188, 189, 687, 688],
        "certainty": "high"
      },
      {
        "reason": "Train Machine Learning or AI models",
        "evidence": [637, 638, 692, 693, 730, 731, 792, 793, 837, 838],
        "certainty": "high"
      },
      {
        "reason": "Targeted and personalized advertisements",
        "evidence": [174, 175, 176, 177, 178, 179, 180, 181, 182, 183],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "Until account deletion",
        "evidence": [493, 494, 495, 496, 502, 503, 504, 505, 506, 507],
        "certainty": "high"
      },
      {
        "duration": "Longer for legal reasons and/or obligations",
        "evidence": [489, 491, 492, 517, 518, 519, 520, 521, 522, 523],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Partners and Affiliates",
        "evidence": [353, 354, 355, 356, 357, 358, 359, 360, 361, 362],
        "certainty": "high"
      },
      {
        "party": "Third party service providers",
        "evidence": [369, 373, 374, 420, 421, 424, 425, 426, 427, 428],
        "certainty": "high"
      },
      {
        "party": "Authorities",
        "evidence": [564, 565, 566, 567, 568, 569, 570, 571, 572, 573],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  },
  {
    "data_types": ["Purchases or other transactions", "Credit/debit card information"],
    "category": "Transaction Data",
    "purposes": [
      {
        "reason": "Process transactions or payments",
        "evidence": [45, 46, 47, 129, 130, 131, 369, 370, 371, 372],
        "certainty": "high"
      },
      {
        "reason": "Provide services, products, features",
        "evidence": [43, 44, 46, 48, 49, 637, 638, 687, 688, 692],
        "certainty": "high"
      },
      {
        "reason": "Improve and personalize services",
        "evidence": [171, 172, 184, 185, 186, 187, 188, 189, 687, 688],
        "certainty": "high"
      },
      {
        "reason": "Targeted and personalized advertisements",
        "evidence": [174, 175, 176, 177, 178, 179, 180, 181, 182, 183],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "Longer for legal reasons and/or obligations",
        "evidence": [489, 491, 492, 517, 518, 519, 520, 521, 522, 523],
        "certainty": "high"
      },
      {
        "duration": "Longer in case of violations",
        "evidence": [491, 519, 520, 521, 522, 523, 585, 586, 587, 588],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Partners and Affiliates",
        "evidence": [353, 354, 355, 356, 357, 358, 359, 360, 361, 362],
        "certainty": "high"
      },
      {
        "party": "Third party service providers",
        "evidence": [369, 370, 371, 372, 373, 374, 420, 421, 424, 425],
        "certainty": "high"
      },
      {
        "party": "Authorities",
        "evidence": [564, 565, 566, 567, 568, 569, 570, 571, 572, 573],
        "certainty": "high"
      }
    ],
    "sensitive": "sensitive"
  },
  {
    "data_types": [
      "Device characteristics and device software",
      "Device identifiers",
      "Device signals",
      "Location-related information",
      "IP address"
    ],
    "category": "Device and Network Information",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [67, 68, 69, 70, 71, 72, 73, 74, 75, 76],
        "certainty": "high"
      },
      {
        "reason": "Improve and personalize services",
        "evidence": [171, 172, 184, 185, 186, 187, 188, 189, 687, 688],
        "certainty": "high"
      },
      {
        "reason": "Security and identification",
        "evidence": [639, 640, 642, 643, 648, 649, 695, 696, 697, 698],
        "certainty": "high"
      },
      {
        "reason": "Targeted and personalized advertisements",
        "evidence": [174, 175, 176, 177, 178, 179, 180, 181, 182, 183],
        "certainty": "high"
      },
      {
        "reason": "Evaluate safety of content and content moderation",
        "evidence": [639, 640, 642, 643, 648, 649, 764, 765, 766, 767],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "Until account deletion",
        "evidence": [493, 494, 495, 496, 502, 503, 504, 505, 506, 507],
        "certainty": "high"
      },
      {
        "duration": "Longer for legal reasons and/or obligations",
        "evidence": [489, 491, 492, 517, 518, 519, 520, 521, 522, 523],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Partners and Affiliates",
        "evidence": [353, 354, 355, 356, 357, 358, 359, 360, 361, 362],
        "certainty": "high"
      },
      {
        "party": "Third party service providers",
        "evidence": [369, 373, 374, 420, 421, 424, 425, 426, 427, 428],
        "certainty": "high"
      },
      {
        "party": "Authorities",
        "evidence": [564, 565, 566, 567, 568, 569, 570, 571, 572, 573],
        "certainty": "high"
      }
    ],
    "sensitive": "partially sensitive"
  },
  {
    "data_types": [
      "Information from cookies and similar technologies",
      "Information from partners, vendors, and third parties"
    ],
    "category": "Tracking and Third-Party Data",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [80, 81, 82, 83, 84, 85, 86, 87, 88, 89],
        "certainty": "high"
      },
      {
        "reason": "Improve and personalize services",
        "evidence": [171, 172, 184, 185, 186, 187, 188, 189, 687, 688],
        "certainty": "high"
      },
      {
        "reason": "Targeted and personalized advertisements",
        "evidence": [174, 175, 176, 177, 178, 179, 180, 181, 182, 183],
        "certainty": "high"
      },
      {
        "reason": "Measurement and analytics",
        "evidence": [200, 201, 214, 215, 353, 354, 355, 356, 357, 358],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "Until account deletion",
        "evidence": [493, 494, 495, 496, 502, 503, 504, 505, 506, 507],
        "certainty": "high"
      },
      {
        "duration": "Longer for legal reasons and/or obligations",
        "evidence": [489, 491, 492, 517, 518, 519, 520, 521, 522, 523],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Partners and Affiliates",
        "evidence": [353, 354, 355, 356, 357, 358, 359, 360, 361, 362],
        "certainty": "high"
      },
      {
        "party": "Third party service providers",
        "evidence": [369, 373, 374, 375, 376, 377, 378, 379, 380, 381],
        "certainty": "high"
      },
      {
        "party": "Advertisers",
        "evidence": [353, 354, 355, 356, 357, 358, 359, 360, 361, 362],
        "certainty": "high"
      },
      {
        "party": "Authorities",
        "evidence": [564, 565, 566, 567, 568, 569, 570, 571, 572, 573],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  },
  {
    "data_types": [
      "Information with special protections (religious views, sexual orientation, political views, health, racial or ethnic origin, etc.)"
    ],
    "category": "Sensitive Personal Information",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [54, 55, 598, 599, 600],
        "certainty": "high"
      },
      {
        "reason": "Improve and personalize services",
        "evidence": [598, 599, 600, 672, 673, 674, 675, 676, 677, 678],
        "certainty": "high"
      },
      {
        "reason": "Research and development",
        "evidence": [598, 599, 600, 743, 744, 745, 746, 747, 748, 749],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "not specified",
        "evidence": [],
        "certainty": "medium"
      }
    ],
    "sharing": [
      {
        "party": "not specified",
        "evidence": [],
        "certainty": "low"
      }
    ],
    "sensitive": "sensitive"
  },
  {
    "data_types": [
      "Interactions with AI at Meta features",
      "Prompts and responses to AI features",
      "Feedback on AI features"
    ],
    "category": "AI Interaction Data",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [39, 40, 125, 126, 127, 637, 638, 692, 693, 730],
        "certainty": "high"
      },
      {
        "reason": "Improve and personalize services",
        "evidence": [186, 187, 188, 189, 687, 688, 717, 718, 719, 720],
        "certainty": "high"
      },
      {
        "reason": "Train Machine Learning or AI models",
        "evidence": [637, 638, 692, 693, 717, 718, 719, 720, 730, 731],
        "certainty": "high"
      },
      {
        "reason": "Research and development",
        "evidence": [717, 718, 719, 720, 743, 744, 745, 746, 747, 748],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "Until account deletion",
        "evidence": [493, 494, 495, 496, 502, 503, 504, 505, 506, 507],
        "certainty": "high"
      },
      {
        "duration": "Longer for legal reasons and/or obligations",
        "evidence": [489, 491, 492, 517, 518, 519, 520, 521, 522, 523],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Partners and Affiliates",
        "evidence": [353, 354, 355, 356, 357, 358, 359, 360, 361, 362],
        "certainty": "high"
      },
      {
        "party": "Third party service providers",
        "evidence": [369, 373, 374, 420, 421, 424, 425, 426, 427, 428],
        "certainty": "high"
      },
      {
        "party": "Authorities",
        "evidence": [564, 565, 566, 567, 568, 569, 570, 571, 572, 573],
        "certainty": "high"
      }
    ],
    "sensitive": "partially sensitive"
  },
  {
    "data_types": ["Hashtags used", "Time, frequency, and duration of activities"],
    "category": "Activity Metadata",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [47, 48, 49, 637, 638, 687, 688, 692, 730, 731],
        "certainty": "high"
      },
      {
        "reason": "Improve and personalize services",
        "evidence": [171, 172, 184, 185, 186, 187, 188, 189, 687, 688],
        "certainty": "high"
      },
      {
        "reason": "Targeted and personalized advertisements",
        "evidence": [174, 175, 176, 177, 178, 179, 180, 181, 182, 183],
        "certainty": "high"
      },
      {
        "reason": "Measurement and analytics",
        "evidence": [200, 201, 214, 215, 353, 354, 355, 356, 357, 358],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "Until account deletion",
        "evidence": [493, 494, 495, 496, 502, 503, 504, 505, 506, 507],
        "certainty": "high"
      },
      {
        "duration": "Longer for legal reasons and/or obligations",
        "evidence": [489, 491, 492, 517, 518, 519, 520, 521, 522, 523],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Partners and Affiliates",
        "evidence": [353, 354, 355, 356, 357, 358, 359, 360, 361, 362],
        "certainty": "high"
      },
      {
        "party": "Third party service providers",
        "evidence": [369, 373, 374, 420, 421, 424, 425, 426, 427, 428],
        "certainty": "high"
      },
      {
        "party": "Advertisers",
        "evidence": [353, 354, 355, 356, 357, 358, 359, 360, 361, 362],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  },
  {
    "data_types": ["Contact information (email, phone number)", "Profile information"],
    "category": "Contact and Profile Information",
    "purposes": [
      {
        "reason": "Create and manage account",
        "evidence": [21, 50, 110, 111, 112, 637, 638, 644, 645, 646],
        "certainty": "high"
      },
      {
        "reason": "Provide services, products, features",
        "evidence": [33, 40, 43, 44, 46, 48, 49, 637, 638, 692],
        "certainty": "high"
      },
      {
        "reason": "Communicate with users",
        "evidence": [202, 644, 645, 646, 703, 704, 705, 739, 740, 741],
        "certainty": "high"
      },
      {
        "reason": "Security and identification",
        "evidence": [639, 640, 642, 643, 648, 649, 695, 696, 697, 698],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "Until account deletion",
        "evidence": [493, 494, 495, 496, 502, 503, 504, 505, 506, 507],
        "certainty": "high"
      },
      {
        "duration": "Longer for legal reasons and/or obligations",
        "evidence": [489, 491, 492, 517, 518, 519, 520, 521, 522, 523],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Partners and Affiliates",
        "evidence": [353, 354, 355, 356, 357, 358, 359, 360, 361, 362],
        "certainty": "high"
      },
      {
        "party": "Third party service providers",
        "evidence": [369, 373, 374, 420, 421, 424, 425, 426, 427, 428],
        "certainty": "high"
      },
      {
        "party": "Authorities",
        "evidence": [564, 565, 566, 567, 568, 569, 570, 571, 572, 573],
        "certainty": "high"
      },
      {
        "party": "General public",
        "evidence": [289, 290, 291, 292, 293, 294, 295, 296, 297, 298],
        "certainty": "high"
      }
    ],
    "sensitive": "partially sensitive"
  },
  {
    "data_types": ["Types of content viewed or interacted with", "How interactions with content occur"],
    "category": "Content Interaction Data",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [42, 43, 44, 637, 638, 687, 688, 692, 730, 731],
        "certainty": "high"
      },
      {
        "reason": "Improve and personalize services",
        "evidence": [171, 172, 184, 185, 186, 187, 188, 189, 687, 688],
        "certainty": "high"
      },
      {
        "reason": "Targeted and personalized advertisements",
        "evidence": [174, 175, 176, 177, 178, 179, 180, 181, 182, 183],
        "certainty": "high"
      },
      {
        "reason": "Train Machine Learning or AI models",
        "evidence": [637, 638, 692, 693, 730, 731, 792, 793, 837, 838],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "Until account deletion",
        "evidence": [493, 494, 495, 496, 502, 503, 504, 505, 506, 507],
        "certainty": "high"
      },
      {
        "duration": "Longer for legal reasons and/or obligations",
        "evidence": [489, 491, 492, 517, 518, 519, 520, 521, 522, 523],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Partners and Affiliates",
        "evidence": [353, 354, 355, 356, 357, 358, 359, 360, 361, 362],
        "certainty": "high"
      },
      {
        "party": "Third party service providers",
        "evidence": [369, 373, 374, 420, 421, 424, 425, 426, 427, 428],
        "certainty": "high"
      },
      {
        "party": "Advertisers",
        "evidence": [353, 354, 355, 356, 357, 358, 359, 360, 361, 362],
        "certainty": "high"
      },
      {
        "party": "Authorities",
        "evidence": [564, 565, 566, 567, 568, 569, 570, 571, 572, 573],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  }
]
